import { Button } from '@acb_devel/design-system';
import { Heading, Text } from '@acb_devel/design-system';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@acb_devel/design-system';
import { useToastContext, ToastRoot, Alert } from '@acb_devel/design-system';
import type { Event } from '@services/events';
import { deleteEvent } from '@services/events';
import { useEventsContext } from '@contexts/EventsContext';

import styles from './DeleteEventModal.module.scss';

export function DeleteEventModal({
  isOpen,
  onClose,
  event,
}: {
  isOpen: boolean;
  onClose: () => void;
  event: Event;
}) {
  const { addToast } = useToastContext();
  const { events, setEvents } = useEventsContext();

  function handleDelete() {
    deleteEvent(event.id)
      .then(() => {
        addToast(
          <ToastRoot>
            <Alert
              variant="success"
              title={`Evento "${event.fullName}" borrado correctamente`}
            />
          </ToastRoot>
        );
        const filteredEvents = events.filter(
          (prevEvent: Event) => prevEvent.id !== event.id
        );
        setEvents(filteredEvents);
        onClose();
      })
      .catch(() => {
        addToast(
          <ToastRoot>
            <Alert variant="error" title="Error al eliminar el evento" />
          </ToastRoot>
        );
      });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalHeader closeModal={onClose} />
      <ModalBody>
        <div className={styles.deleteEventModal}>
          <Heading as="h2" variant="heading-2">
            {`¿Estás seguro que quieres borrar el evento "${event.fullName}"?`}
          </Heading>
          <Text variant="body-1">
            Si lo borras desaparecerá del formulario de inscripción.
          </Text>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={styles.deleteEventModal__footer}>
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="solid" onClick={handleDelete}>
            Borrar
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
